// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-1QzC3","lds-ring":"index-lds-ring-3vZrk"};